import api from '../../plugins/api';

// POST /api/crm/vin-blacklist/delete/{id} — убрать запись из списка.
const deleteVinFromBlacklist = (id) => {
  return api.post(`/api/crm/vin-blacklist/delete/${id}`);
};

export default deleteVinFromBlacklist;
